import { GDFHotPollyTypes } from '../../../../gdf/type';

export default function HotPolyDescriptions({ text, polyType }: { text: string; polyType: GDFHotPollyTypes }) {
    if (!text) {
        return <></>;
    }
    if (polyType === GDFHotPollyTypes.route) {
        return <></>;
    }

    if (polyType === GDFHotPollyTypes.tropical_cyclone) {
        const lines = text.split('\n');
        const segments = lines.map((x) => x.split(':', 2));
        if (segments.every((x) => x.length === 2)) {
            return (
                <>
                    {segments.map((x, i) => (
                        <>
                            <div key={2 * i}>{x[0]}:</div>
                            <div key={2 * i + 1}>{x[1]}</div>
                        </>
                    ))}
                </>
            );
        }
    }

    return (
        <>
            <div style={{ gridColumn: 1 / 3 }}>Description:</div>
            <div style={{whiteSpace: 'pre', textWrap:'wrap'}}>{text}</div>
        </>
    );
}
